<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="p-20">
    <el-breadcrumb-item :to="{ path: '/home' }">
      <span @click="click"> Главная </span>
    </el-breadcrumb-item>
    <el-breadcrumb-item
      v-for="link in breadcrumbs"
      :key="link.path"
      :to="link.path"
    >
      {{ link.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import breadcrumbs from '@/datas/breadcrumbs'

export default {
  name: 'Breadcrumbs',
  props: {
    crumb: {
      type: String,
      default: '',
    },
    click: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      breadcrumbs: breadcrumbs[this.crumb],
    }
  },
}
</script>
